<template>
    <section :style=" { 'font-family': familia } " class="pa-3">
        <v-row>
            <v-col cols="3" :style="{ background: color.primario }" >
                <img :src="foto" v-if="foto" 
                style="max-height: 100%; max-width: 100%;width: 300px; height: 300px;  object-fit: cover; display: block; margin:auto; border-radius: 50%;" />
            </v-col>
            <v-col cols="3" :style="{ background: color.secundario, color: color.texto }"  v-if="informacion.descripcion">
                <p class="text-center" :style="{ 'font-size': tamanio + 'px' }">{{ informacion.descripcion }}</p>
            </v-col>
            <v-col :style="{ background: color.primario, color: color.texto }">
                <p class="text-capitalize text-center font-weight-black pa-0 ma-0" :style="{ 'font-size': calcularTamanioFuente('h1') }">
                    {{ informacion.nombre}}
                </p>
                <div class=" text-capitalize font-weight-bold text-center pa-0 ma-0" :style="{ 'font-size': calcularTamanioFuente('h3') }">
                    <p v-if="informacion.estudios">
                        <v-icon :color="color.texto">
                            mdi-certificate
                        </v-icon>
                        {{ informacion.estudios }}
                    </p>
                    <p>
                        <v-icon :color="color.texto">
                            mdi-mother-heart
                        </v-icon>
                        {{ informacion.edad }}
                    </p>
                    <p>
                        <v-icon :color="color.texto">
                            mdi-account-heart
                        </v-icon>
                        {{ informacion.estadoCivil }}
                    </p>
                </div>
                <div class="text-center">
                    <span v-for="(chip, ci) in informacion.chips" :key="ci">
                        <v-chip
                            class="ma-2"
                            :color="color.terciario"
                            outlined
                            pill>
                            {{ chip }}
                        </v-chip>
                    </span>
                   
                </div>
                
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="6" :style="{ background: color.terciario }">
                <p 
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Contacto
                </p >
                <div :style="{ 'font-size': tamanio + 'px' }">
                     <p v-if="contacto.email">
                        <v-icon>
                            mdi-email
                        </v-icon>
                        {{ contacto.email }}
                    </p>
                    <p v-if="contacto.telefono">
                        <v-icon>
                            mdi-phone
                        </v-icon>
                        {{ contacto.telefono }}
                    </p>                
                    <p v-if="contacto.web">
                        <v-icon>
                            mdi-web
                        </v-icon>
                        <a  target="_blank" :href="contacto.web">{{ contacto.web }}</a>
                        
                    </p>
                    <span class="d-block text-truncate">
                        <p v-if="contacto.youtube"  >
                            <v-icon>
                                mdi-youtube
                            </v-icon>
                            <a  target="_blank" :href="contacto.youtube">{{ contacto.youtube }}</a>
                        
                            </p> 
                    </span>
                    <span class="d-block text-truncate">
                        <p v-if="contacto.github"  >
                            <v-icon>
                                mdi-github
                            </v-icon>
                            <a  target="_blank" :href="contacto.github">{{ contacto.github }}</a>
                        </p>
                    </span>
                </div>
               
                <div class="separador" :style="{ 'color': color.secundario }"></div>
                <p
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Formación académica
                </p>
                <div 
                v-for="(escuela, index) in escuelas" :key="index"
                :style="{ 'font-size': tamanio + 'px' }">
                    <h4>
                        <v-icon>
                            mdi-town-hall
                        </v-icon>
                        {{  escuela.nombre }} || 
                        <span class="font-weight-thin">
                            {{ escuela.periodo}}
                        </span>
                    </h4>
                    <p class="font-weight-medium">{{ escuela.titulo }}</p>
                    <p  :style="{ 'font-size': tamanio - 5 + 'px' }">{{ escuela.lugar }}</p>
                    <br>
                </div>

               <div class="separador" :style="{ 'color': color.secundario }"></div>
                
                <p
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Experiencia laboral
                </p>
                <div 
                v-for="(empleo, indice) in empleos" :key="indice"
                :style="{ 'font-size': tamanio + 'px' }">
                    <h4>
                         <v-icon>
                            mdi-domain
                        </v-icon>
                        {{  empleo.nombre }} || 
                        <span class="font-weight-thin">
                            {{ empleo.periodo }}
                        </span>
                    </h4>
                    <p :style="{ 'font-size': tamanio - 5 + 'px' }">{{ empleo.lugar }}</p>
                    <p class="font-weight-medium">Puesto: {{ empleo.puesto}}</p>
                    <p class="font-weight-thin">Actividades realizadas</p>
                    <p style="white-space: pre;" :style="{ 'font-size': tamanio - 4 + 'px' }">{{ empleo.descripcion }}</p>
                    <br>
                </div>
            </v-col>

            <v-col class="ml-3">
                <p
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Hábilidades
                </p>
                <div class="row mt-2">
                    <div v-for="(habilidad, i) in habilidades" :key="i" :style="{ 'font-size': tamanio + 'px' }">

                        <p>
                            <v-icon>
                                mdi-check
                            </v-icon>
                            {{  habilidad.nombre }}
                        </p>
                        <div v-if="habilidad.mostrarGrafica" class="col-lg-4 col-12">
                            <v-progress-circular
                              :size="100"
                              :width="15"
                              :value="habilidad.porcentaje"
                              :color="habilidad.color"
                            >
                              {{ habilidad.porcentaje }} %
                            </v-progress-circular>
                        </div>
                    </div>
                </div>

                <div class="separador" :style="{ 'color': color.secundario }"></div>

                <p
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Idiomas
                </p>
                <div 
                v-for="(idioma, j) in idiomas" :key="j"
                :style="{ 'font-size': tamanio + 'px' }">
                    <div class="row">
                        <div class="col" cols="4">
                            <h4>{{ idioma.nombre}}</h4>
                        </div>
                        <div class="col">
                            <v-progress-linear
                              v-model="idioma.porcentaje"
                              :color="idioma.color"
                              height="25"
                            >
                              <strong>{{ idioma.porcentaje }}%</strong>
                            </v-progress-linear>
                        </div>
                    </div>
                    
                </div>

                <div class="separador" :style="{ 'color': color.secundario }"></div>

                <p
                class="font-weight-bold text-center" 
                :style="{ 'color': color.primario, 'font-size': calcularTamanioFuente('h3') }">
                    Pasatiempos
                </p>
                <p style="white-space: pre;" :style="{ 'font-size': tamanio + 'px' }">
                    {{ pasatiempos }}
                </p>
            </v-col>
        </v-row>
        <v-row :style="{ 'background-color': color.secundario }">
            <img src="@/assets/logo.png" width="150" style="margin: 0 auto">
        </v-row>
    </section>
</template>
<script>
    export default{
        name: "PlantillaCv",
        props: ["informacion", "contacto", "escuelas", "empleos", "habilidades", "idiomas", "pasatiempos", "foto", "color", "tamanio", "familia"],

        methods:{
            calcularTamanioFuente(clase){
                switch(clase){
                    case 'h1':
                        return this.tamanio + 23 + 'px'
                        
                    case 'h3':
                        return this.tamanio + 6 + 'px'
                        

                    case 'h6':
                        return this.tamanio + 3 + 'px'
                        

                    default:
                        return 12 + 'px'
                }
            }
        }
    }
</script>
<style scoped>
    .separador{
        margin: 10px;
        display:block;
        position: relative;
        border:  solid ;
        border-radius: 5px;
    }
    p{  
        margin: 0 !important;
    }

    a:link, a:visited {
        max-width: 350px;
        color: black !important;
        text-decoration: none;
    }
</style>